import React, { useEffect, useState } from 'react';
import { CRow, CCol, CForm, CFormInput, CButton } from '@coreui/react';

import adminApi from 'services/adminApi';

import './ResetPassword.scss';
import AccountDefaultModal from './AccountDefaultModal';

export default function ResetPassword() {
  const [userList, setUserList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editUserDetail, setEditUserDetail] = useState({
    username: '',
    password: '',
    userId: '',
  });

  useEffect(() => {
    async function fetchUserList() {
      const res = await adminApi({ url: '/user' });
      const { isSuccess, data } = await res.json();
      if (isSuccess) {
        setUserList(data || []);
      }
    }
    fetchUserList();
  }, []);

  const handleOpenModal = (user) => {
    setEditUserDetail({
      username: user.email || '',
      password: editUserDetail.password || '',
      userId: user.id || '',
    });
    setIsModalOpen(true);
  };

  return (
    <div className="user-detail-container reset">
      <div className="d-flex justify-content-between align-items-center mb-4 reset-header">
        <h3>Reset Default System User</h3>
        <CButton
          color="info"
          style={{ color: 'white' }}
          onClick={() => {
            localStorage.removeItem('token');
            localStorage.removeItem('userId');
            window.location.href = '/login';
          }}
        >
          Back to Login
        </CButton>
      </div>

      <div className="reset-list">
        <CForm className="reset-form">
          {userList[0] && ( // Chỉ hiển thị phần tử đầu tiên
            <CRow className="mb-3">
              <CCol md={6} sm={6} xs={6}>
                <CFormInput
                  type="text"
                  id={`username-${userList[0].id}`}
                  value={userList[0].email}
                  readOnly
                />
              </CCol>

              <CCol
                md={6}
                sm={6}
                xs={6}
                className="d-flex align-items-end justify-content-start"
              >
                <CButton
                  color="primary"
                  onClick={() => handleOpenModal(userList[0])}
                >
                  Reset
                </CButton>
              </CCol>
            </CRow>
          )}
        </CForm>
      </div>

      <AccountDefaultModal
        userId={editUserDetail.userId}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        setUserList={setUserList}
      />
    </div>
  );
}
